import { authHeader, config } from '../_helpers';

export const solrService = {
    getAll
};

function getAll(path, searchparam) {

    const requestOptions = {
        method: 'POST',
        headers: authHeader(),
        timeout: 60 * 3 * 1000,
        body: JSON.stringify(searchparam)
    };

    //return fetch(config.solrApiUrl + '/' + path, requestOptions).then(handleResponse, handleError);
    return timeoutPromise(180000,fetch(config.solrApiUrl + '/' + path, requestOptions).then(handleResponse, handleError));

}

function handleResponse(response) {
    return new Promise((resolve, reject) => {
        if (response.ok) {
            // return json if it was returned in the response
            var contentType = response.headers.get("content-type");
            if (contentType && contentType.includes("application/json")) {
                response.json().then(json => resolve(json));
            } else {
                resolve();
            }
        } else {
            // return error message from response body
            response.text().then(text => reject(text));
        }
    });
}

function handleError(error) {
    return Promise.reject(error && error.message);
}

function timeoutPromise(ms, promise) {
  return new Promise((resolve, reject) => {
    const timeoutId = setTimeout(() => {
      reject(new Error("promise timeout"))
    }, ms);
    promise.then(
      (res) => {
        clearTimeout(timeoutId);
        resolve(res);
      },
      (err) => {
        clearTimeout(timeoutId);
        reject(err);
      }
    );
  })
}


// WEBPACK FOOTER //
// ./src/_services/solr.service.js